<h2 class="fw-bold mb-4 text-center text-lg-start">
  {{
    "Con Akky Pro, tus beneficios crecen al ritmo de tus compras" | translate
  }}
</h2>

<span class="text-banner px-3">
  {{
    "Diseñamos este programa de beneficios para premiar a nuestros clientes mayoristas, quienes invierten de forma estratégica en servicios digitales para potenciar el crecimiento de sus negocios."
      | translate
  }}
</span>
